import { render, staticRenderFns } from "./PersonalPaymentSvg.vue?vue&type=template&id=f0b8c54c&"
import script from "./PersonalPaymentSvg.vue?vue&type=script&lang=js&"
export * from "./PersonalPaymentSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports